import type { EventData } from "../data";

interface ProblemProps {
  event: EventData;
}

const Problem: React.FC<ProblemProps> = ({ event }) => {
  return (
    <section className="bg-white py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-[1100px] mx-auto grid grid-cols-1 md:grid-cols-[1fr_2fr] gap-10 md:gap-0">
        <h2
          data-aos="fade-up"
          className="text-3xl md:text-4xl lg:text-[40px] font-display font-[550] leading-tight"
        >
          <span className="text-[#050B17] block">{event.problem.headingLead}</span>
          <span className="text-[#E9750E] block">{event.problem.headingHighlight}</span>
        </h2>

        <div
          data-aos="fade-up"
          data-aos-delay="100"
          className="space-y-5 text-[#475467] text-base md:text-lg lg:text-xl leading-relaxed"
        >
          {event.problem.paragraphs.map((paragraph, pIdx) => (
            <p key={pIdx}>
              {paragraph.segments.map((segment, sIdx) =>
                segment.bold ? (
                  <strong key={sIdx} className="text-[#1D2939] font-medium">
                    {segment.text}
                  </strong>
                ) : (
                  <span key={sIdx}>{segment.text}</span>
                )
              )}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};

export { Problem };
